(function ($) {
	$(document).ready(function () {
		/* change header bg color on scroll */
		const siteNavOpenSearch = "has-open-search";
		const siteNav = $("#siteNav");

		$("#searchToggle").click(function () {
			siteNav.addClass(siteNavOpenSearch);
			$("body").addClass(siteNavOpenSearch);
		});

		$(".is-mega-menu").on("click", function (e) {
			if ($(e.target).parent().hasClass("is-mega-menu")) {
				e.stopPropagation();
				e.preventDefault();
			}

			if ($(this).hasClass("menu-open")) {
				$(this).removeClass("menu-open");
				$(this).children().removeClass("menu-drop");
				siteNav.removeClass("megamenu-active");
				$(".is-mega-menu.menu-open").removeClass("menu-open");
				$(".megamenu-active").removeClass("megamenu-active");
			} else {
				$(".menu-open").removeClass("menu-open");
				$(".menu-drop").removeClass("menu-drop");
				$(this).addClass("menu-open");
				$(this).children().addClass("menu-drop");
				siteNav.addClass("megamenu-active");
			}
		});

		const searchOffCanvas = document.getElementById("offcanvasTop");
		searchOffCanvas.addEventListener("hide.bs.offcanvas", function () {
			siteNav.removeClass(siteNavOpenSearch);
			$("body").removeClass(siteNavOpenSearch);
		});

		// On click outside siteNav, close siteNav
		$(document).on("click", function (e) {
			let activeMenu = $(".megamenu-active");

			if (activeMenu.length > 0) {
				const clickedNavLink = e.target.classList.contains("menu-drop");
				if (clickedNavLink === false) {
					$(".is-mega-menu.menu-open").removeClass("menu-open");
					$(".megamenu-active").removeClass("megamenu-active");
				}
			}
		});
		// if click on anything else, remove active class.
	});
})(jQuery);